/* Built In Imports */
import React from 'react';

/* External Imports */
import {
  AspectRatio, Box, Image, Link, Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay, Text, useDisclosure
} from '@chakra-ui/react';
import LazyLoadImageComponent from '@components/UI/LazyLoadImageComponent';

/* Internal Imports */
/* Components */
import StructuredTextContent from '@components/UI/StructuredTextContent';
import { refineUrlDomain } from '@components/Utility/utils';
import config from '@config';
/* Services */

/**
 * Renders the BannerContent component
 *
 * @param {object} sectionContent - Data for section
 * @param {string} region - Region of the section
 * @param {string} lang - Language of the section
 * @returns {ReactElement} BannerContent component
 */

const BannerContent = ({ sectionContent, region, language }) => {
  const {
    isOpen: isFirstModalOpen,
    onOpen: onFirstModalOpen,
    onClose: onFirstModalClose,
  } = useDisclosure();
  const bannerDetail = sectionContent.body?.find(
    el => el.sectionId == 'HeaderBanner'
  );
  const bannerData = bannerDetail?.sectionContent;
  return (
    <>
      <Image
        src={bannerData[2]?.image?.url}
        alt={bannerData[2]?.image?.alt}
        title={bannerData[2]?.image?.title}
        display={{ base: 'none !important', lg: 'block !important' }}
        w="100%"
      />
      <Image
        src={bannerData[2]?.mobileImage?.url}
        alt={bannerData[2]?.mobileImage?.alt}
        title={bannerData[2]?.mobileImage?.title}
        display={{ base: 'block !important', lg: 'none !important' }}
        w="100%"
      />
      {language == 'ta' ||
        language == 'te' ||
        language == 'hi' ||
        language == 'es' ? (
        // (language != 'en' && region == 'in')
        <>
          <Box
            pos="absolute"
            left={{
              base: 'calc((100% - 220px) / 2)',
              lg: 'calc((100% - 182px) / 2)',
            }}
            textAlign="center"
            top={{ base: '0.5%', lg: '0.9%' }}
          >
            <LazyLoadImageComponent
              src={`${config.imgPath}/d/46272/1647433381-sg-ex-logo-3x.png`}
              // src="https://images.sadhguru.org/d/46272/1647433381-sg-ex-logo-3x.png"
              width="80%"
              title="logo"
              alt="logo"
            />
            <Text
              color="#000000"
              fontFamily="FedraSansStd-book"
              fontSize="12px"
              margin="10px 0 10px 0"
            >
              {bannerData[0]?.titleSubtext}
            </Text>
            <Box
              position="absolute"
              margin-left="calc((100% - 65px) / 2)"
              top={{ base: '100%', sm: '100%', lg: '100%' }}
              left={{ base: '0' }}
              right={{ base: '0' }}
              margin="0 auto"
              width={{ base: '104px', lg: '104px' }}
            >
              {/* <LazyLoadImageComponent
                src={`${config.imgPath}/d/46272/1644995290-play.png`}
                title="play"
                alt="play"
                // src="https://images.sadhguru.org/d/46272/1644995290-play.png"
                // onClick={isFirstModalOpen}
                // cursor="pointer"
              /> */}
            </Box>
            <Modal
              isOpen={isFirstModalOpen}
              onOpen={onFirstModalOpen}
              onClose={onFirstModalClose}
            >
              <ModalOverlay bgColor="black" />
              <ModalContent bgColor="transparent" maxW="container.sm">
                <ModalCloseButton
                  top={{ base: '-34px', md: '-38px', lg: '-20px' }}
                  right={{ base: '12px', md: '8px', lg: '-70px' }}
                  color="#fff"
                  fontSize={{ base: '18px', md: '24px', lg: '24px' }}
                  _focus={{
                    boxShadow: 'none',
                  }}
                />
                <ModalBody p="0" m={{ base: '0 10px', md: '0', lg: '0' }}>
                  <AspectRatio>
                    <iframe
                      // src={`https://www.youtube.com/embed/'${bannerData[6]?.text}')`}
                      src="https://www.youtube.com/embed/lvlainzP5ck"
                      frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                      style={{ 'z-index': '1' }}
                      width="auto"
                    ></iframe>
                  </AspectRatio>
                </ModalBody>
              </ModalContent>
            </Modal>
          </Box>
        </>
      ) : (
        <>
          {/* exlusive main banner logo place holder*/}
        </>
      )}
      <Box
        background="#121212"
        padding={{ base: '25px', lg: '55px 200px 55px 200px' }}
        w={{ base: 'auto', lg: '1000px', '2xl': '1400px' }}
        position="relative"
        top={{ base: '9px', lg: '-200px' }}
        left={{
          base: '0',
          lg: 'calc((100% - 1000px) / 2)',
          '2xl': 'calc((100% - 1400px) / 2)',
        }}
        textAlign="center"
        className="banner_content"
      >
        {(region == 'in' && language == 'en') || language == 'en' ? (
          <>
            <Text
              color="#FFBD31"
              fontSize="18px"
              letterSpacing="2px"
              lineHeight="30px"
              textTransform="uppercase"
              margin="0 0 10px 0"
            >
              {bannerData[0]?.titleSubtext}
            </Text>
          </>
        ) : (
          ''
        )}
        <h1>
          <Text
            color="#FFFFFF"
            fontSize={{ base: '22px', lg: '38px' }}
            lineHeight="1.29"
            fontFamily="FedraSansStd-A-medium"
            margin="0 0 20px 0"
          >
            {bannerData[0]?.titleText}
          </Text>
        </h1>
        <Text
          color="#d0caba"
          fontSize={{ lg: '14px', base: '16px' }}
          fontFamily="FedraSansStd-book"
        >
          {bannerData[1]?.text}
        </Text>

        <Text
          color="#ffbd31"
          fontSize="22px"
          fontFamily="FedraSansStd-book"
          m="40px 0 30px 0"
          className="langopt-structure"
        >
          {StructuredTextContent(bannerData[4]?.body)}
        </Text>

        <Box>
          <Link
            w={{ base: '98%', lg: '368px' }}
            h="81px"
            m="20px auto"
            fontFamily="FedraSansStd-A-medium"
            fontSize="20px"
            lineHeight="81px"
            textAlign="center"
            display="block"
            background="#ffbd31"
            color="#121212"
            borderRadius="7px"
            className="buttonlink"
            // href={bannerData[3]?.linkUrl}
            href={refineUrlDomain(bannerData[3]?.linkUrl, region, language)}
            _hover={{ textDecor: 'none' }}
            cursor="pointer"
          >
            {bannerData[3]?.buttonText}
          </Link>
        </Box>
        <Box>
          <Text
            fontSize="18px"
            fontFamily="FedraSansStd-medium"
            color="#b0a999"
            margin="27px 0 0 0"
            className="loginlink"
          >
            {StructuredTextContent(bannerData[5]?.body)}
          </Text>
        </Box>
      </Box>
    </>
  );
};

export default BannerContent;
